import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=674265ae&scoped=true"
import script from "./ConsentBanner.vue?vue&type=script&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=674265ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674265ae",
  null
  
)

export default component.exports